// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-user-manage .normal-table-wrap[data-v-3e453f87],.account-user-manage .normal-table-wrap[data-v-3e453f87] .el-empty,.account-user-manage .normal-table-wrap[data-v-3e453f87] .normal-table{height:100%;min-height:var(--base-main-router-body-avaliable-height-with-action-bar)}", ""]);
// Exports
module.exports = exports;
